export default "__VITE_ASSET__DvKYvh3k__"